import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#0056B3",
    },
    secondary: {
      main: "#FFB74D",
    },
    error: {
      main: "#D32F2F",
    },
    warning: {
      main: "#757575",
    },
    success: {
      main: "#388E3C",
    },
    background: {
      default: "#F5F5F5",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#333333",
      secondary: "#555555",
    },
  },
  typography: {
    fontFamily: "Lato, Roboto, Arial, sans-serif",
    h1: {
      fontWeight: 700,
      fontSize: "2.25rem",
      letterSpacing: "0.015em", // Adjusted for smoother readability
      color: "#333333",
    },
    h2: {
      fontWeight: 600,
      fontSize: "1.875rem",
      letterSpacing: "0.015em",
      color: "#333333",
    },
    body1: {
      fontSize: "1rem",
      lineHeight: "1.8", // Slightly increased for better readability
      color: "#555555",
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
      letterSpacing: "0.04em", // Refined for polished button text
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          padding: "8px 16px",
          boxShadow: "0 3px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow for more depth
          "&:hover": {
            backgroundColor: "#004080",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)", // More defined shadow for cards
          padding: "24px",
        },
      },
    },
  },
});
